
import React, { Component } from 'react';
import { connect } from 'react-redux';
import logo from './logo.svg';
import './App.css';
import Login from './Components/Login/Login';
import LastReportWidget from './Components/LastReportWidget/LastReportWidget';
import ReportFeedWidget from './Components/ReportFeedWidget/ReportFeedWidget';
import ReportFeedPage from './Components/ReportFeedPage/ReportFeedPage';
import LeaderboardWidget from './Components/LeaderboardWidget/LeaderboardWidget';
import StartPage from './Components/StartPage/StartPage';
import Dashboard from './Components/Dashboard/Dashboard';
import { Route, withRouter, Switch } from 'react-router-dom';
import { wsOnMessageAction, wsOnMessageEventConfirmed } from "./Actions/WebsocketActions.js";
import { readLeaderboardAction } from "./Actions/LeaderboardActions.js";
import * as Constants from "./Common/constants";
import TournamentsPage from './Components/TournamentsPage';
import Tournament from './Components/Tournament';
import PlayerGroupPage from './Components/PlayerGroupPage';
import PlayerPage from './Components/PlayerPage';

import LeaderboardPage from './Components/Leaderboard/LeaderboardPage';

import SockJS from 'sockjs-client';
import { Stomp } from '@stomp/stompjs';
import Footernav from './Components/Footernav/Footernav.js';
import Help from './Components/Footernav/Help.js';

class App extends Component {

  constructor(props) {
    super();

    var url = Constants.WS_SERVER;

    this.onMessage = this.onMessage.bind(this);
    this.onMessagePlayerEvent = this.onMessagePlayerEvent.bind(this);
    this.onMessageEventConfirmed = this.onMessageEventConfirmed.bind(this);
    this.listenOnWS = this.listenOnWS.bind(this);
    
    //props.readLeaderboardAction();

    // console.log("CONNECTING  to " + url);

    // var ws = new WebSocket(url);

    // ws.onconnect = function (e) {
    //   console.log("connected to " + url);
    // }
    // ws.onerror = function (error) {
    //   console.log('WebSocket Error ' + error);
    // };
    // ws.onclose = function (event) {
    //   console.log("Remote host closed or refused WebSocket connection");
    //   console.log(event);
    // };
    // ws.onmessage = this.onMessage;


  }

  componentDidMount() {
    this.listenOnWS(this.onMessagePlayerEvent);
    this.listenOnWSEventConfirmed(this.onMessageEventConfirmed);
  }
  
  render(){
    console.log("App render");
    //return <TournamentsPage />
   
    return this.renderRoute();
  }

  renderRoute() {
    
    return (
    <div className='pageContainerDiv'>
      <div className="pageContentDiv">
        <Footernav />
        <Switch>
          <Route path={`/help`} component={Help} />
          <Route path={`/login`} component={Login} />
          <Route path={`/last`} component={LastReportWidget} />
          <Route path={`/feed`} component={ReportFeedPage} />
          <Route path={`/leaderboard`} component={LeaderboardPage} />
          <Route path={`/tournaments`} component={TournamentsPage} />
          <Route path={`/tournament`} component={LeaderboardPage} />
          <Route path={`/playergroup`} component={PlayerGroupPage} />
          <Route path={`/player`} component={PlayerPage} />
          <Route path={`/`} component={TournamentsPage} />

        </Switch>
      </div>
    </div>);

  }

  onMessagePlayerEvent(e) {
    console.log('onMessagePlayerEvent:' + e);
    this.props.wsOnMessageAction(e.body);
  }
  onMessageEventConfirmed(e) {
    console.log('onMessageEventConfirmed:' + e);
    this.props.wsOnMessageEventConfirmed(e.body);
  }

  onMessage(messageEvent) {
    console.log("on message...", messageEvent);
    this.props.wsOnMessageAction(messageEvent.data);
  }

  listenOnWS(onMessagePlayerEvent) {
    console.log("Connecting to GSS websocket..");
    //const client = Stomp.client('ws://134.209.230.231:8080/gss'); 

    var client = Stomp.over(createNewWebsocket);

    client.connect({}, function (frame) {
      console.log('Connected  GSS websocket: ' + frame);
      client.subscribe('/topic/playerevent', function (e) {

        onMessagePlayerEvent(e);

      });
    }, function (message) {
      console.log("GSS Web socket error:" + message);
    });
    client.onclose = function(){
      console.log("Closing websocket...")
    }

  }

  listenOnWSEventConfirmed(onMessageEventConfirmed) {
    console.log("Connecting to GSS websocket..");
    //const client = Stomp.client('ws://134.209.230.231:8080/gss'); 
    
    var client = Stomp.over(createNewWebsocket);

    client.connect({}, function (frame) {
      console.log('Connected  GSS websocket: ' + frame);
      client.subscribe('/topic/confirmation', function (e) {

        onMessageEventConfirmed(e);

      });
    }, function (message) {
      console.log("GSS Web socket error:" + message);
    });

  }


}

/**
 * Get data from store
 * @param state
 */
const mapStateToProps = state => (
  {
    test: state
  }
);

/**
* 
*/
const mapActionsToProps = {
  wsOnMessageAction,
  wsOnMessageEventConfirmed,
  readLeaderboardAction
};
export default withRouter(connect(mapStateToProps, mapActionsToProps)(App));

function createNewWebsocket(){
  var socket = new SockJS(Constants.SERVER + "/gss");

  socket.onclose = function () {

    console.log('GSS Web socket close');
    socket = null
    setTimeout(createNewWebsocket, 5000)
  
  };
  socket.onerror = function () {

    console.log('GSS Web socket error');

  };
  return socket;
}


// WEBPACK FOOTER //
// ./src/App.js